import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvitationsComponent } from './invitations.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [InvitationsComponent],
  imports: [
    CommonModule,SharedModule
  ],
  exports: [InvitationsComponent]
})
export class InvitationsModule { }
